import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const BUCKET_COUNT = 15;

export default function PayChart({ runs }) {
  const totals = runs.map((r) => ({
    total: r.options_optionValue + r.rsu_rsuValue,
    options: r.options_optionValue,
    rsu: r.rsu_rsuValue,
  }));

  const min = Math.min(...totals.map((t) => t.total));
  const max = Math.max(...totals.map((t) => t.total));
  const size = (max - min) / BUCKET_COUNT;

  const buckets = Array.from({ length: BUCKET_COUNT }, (_, i) => ({
    range:
      i === 0
        ? `<$${((min + size) / 1_000_000).toFixed(1)}M`
        : i === BUCKET_COUNT - 1
          ? `>$${((max - size) / 1_000_000).toFixed(1)}M`
          : `$${((min + i * size) / 1_000_000).toFixed(1)}M–$${((min + (i + 1) * size) / 1_000_000).toFixed(1)}M`,
    options: 0,
    rsu: 0,
    count: 0,
    optionsRelativeCount: 0,
    rsuRelativeCount: 0,
  }));

  totals.forEach(({ total, options, rsu }) => {
    const i = Math.min(Math.floor((total - min) / size), BUCKET_COUNT - 1);
    if (!buckets[i]) return;
    buckets[i].options += options;
    buckets[i].rsu += rsu;
    buckets[i].count += 1;
    buckets[i].optionsRelativeCount += options / total;
    buckets[i].rsuRelativeCount += rsu / total;
  });

  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload?.length) return null;
    const totalRuns = runs?.length || 1;

    const { options, rsu, count } = payload[0]?.payload;
    const total = options + rsu;
    const pct = ((count / totalRuns) * 100).toFixed(1);
    if (!count) return null;

    return (
      <div
        style={{
          background: "var(--white)",
          border: "0.5px solid var(--secondary)",
          borderRadius: "var(--border-radius-md)",
          padding: "10px 14px",
          fontSize: 13,
          minWidth: 200,
        }}
      >
        <p
          style={{
            margin: "0 0 8px",
            fontWeight: 500,
            color: "var(--color-text-primary)",
          }}
        >
          {label} Range
        </p>
        <p style={{ margin: "2px 0", color: "var(--secondary-1)" }}>
          Avg. RSUs: ${Math.round(rsu / count).toLocaleString()}
        </p>
        <p style={{ margin: "2px 0", color: "var(--primary-1)" }}>
          Avg. Options: ${Math.round(options / count).toLocaleString()}
        </p>
        <p>Avg. Total: ${Math.round(total / count).toLocaleString()}</p>
        <p
          style={{
            margin: "6px 0 2px",
            borderTop: "0.5px solid var(--secondary)",
            paddingTop: 6,
            color: "var(--secondary)",
          }}
        >
          {count} runs ({pct}%)
        </p>
      </div>
    );
  };

  return (
    <ResponsiveContainer width="100%" height={400}>
      <BarChart
        data={buckets}
        margin={{ top: 20, right: 20, bottom: 40, left: 0 }}
      >
        <XAxis
          dataKey="range"
          angle={-45}
          textAnchor="end"
          interval={0}
          height={60}
          tick={{ fontSize: 11 }}
          label={{
            value: "Total Award Price Range",
            position: "insideBottom",
            offset: -25,
          }}
        />
        <YAxis
          tickFormatter={(v) => `${v.toLocaleString()}`}
          width={60}
          label={{
            value: `Number of Trials within Range`,
            angle: -90,
            position: "insideLeft",
            offset: 10,
            dy: 90,
          }}
        />
        <Tooltip
          content={<CustomTooltip />}
          // formatter={(val, name) => {
          //   console.log(name);
          //   return [
          //     `$${Math.round(val).toLocaleString()}`,
          //     name === "Options" ? "Avg. Options" : "Avg. RSUs",
          //   ];
          // }}
          // labelFormatter={(label) => `Total range starting ${label}`}
        />
        <Legend verticalAlign="top" />
        <Bar
          dataKey="optionsRelativeCount"
          name="Options"
          stackId="a"
          fill="var(--primary-1)"
        />
        <Bar
          dataKey="rsuRelativeCount"
          name="RSUs"
          stackId="a"
          fill="var(--secondary-1)"
        />
      </BarChart>
    </ResponsiveContainer>
  );
}
